import { registerBrick } from 'olympe';
import {ReactBrick, useMUITheme} from "@olympeio/core";
import {ThemeProvider} from "@mui/material/styles";
import {Button} from "@mui/material";
import React from "react";

export default class TermsConditions extends ReactBrick {

    /**
     * @override
     */
    static getReactComponent($) {
        return (props) => {
            const theme = useMUITheme($);
            return (
                <ThemeProvider theme={theme}>
                    <div className="w-[95%] h-full overflow-y-auto p-4">
                        <div className="w-full h-full flex items-center justify-center">
                            <div className="w-full h-full">
                                <h2 className="text-xl font-semibold mb-4">Clause de non-responsabilité</h2>
                                <div className="text-sm text-gray-700 mb-6">
                                    <p className="mb-4">
                                        Ce logiciel est fourni à des fins éducatives et expérimentales uniquement. En cliquant sur "Accepter", vous reconnaissez expressément que :
                                    </p>
                                    <ul className="list-disc pl-5 space-y-2">
                                        <li>Vous utilisez ce service sous votre entière responsabilité.</li>
                                        <li>Vous restez en pleine possession et en plein contrôle de vos fonds hébergés sur Binance.</li>
                                        <li>L’outil agit uniquement via l’API que vous fournissez, avec des droits limités à l’exécution d’ordres (sans droits de retrait).</li>
                                        <li>Aucun transfert de fonds n’est effectué ou géré par le développeur.</li>
                                        <li>Ce service ne constitue pas un conseil en investissement ni une offre de gestion de fortune au sens de la législation suisse (LEFin/LSFin).</li>
                                        <li>Le développeur n’est pas une entité régulée par la FINMA et ne propose aucune prestation financière au sens réglementaire.</li>
                                        <li>Le trading de cryptomonnaies comporte des risques élevés, pouvant entraîner la perte totale ou partielle de votre capital.</li>
                                        <li>Aucune garantie de performance, de gain ou de résultat n’est donnée, ni implicite ni explicite.</li>
                                    </ul>
                                    <p className="mb-4 mt-4">
                                        En utilisant ce service, vous confirmez avoir compris les risques et exonérez le développeur de toute responsabilité liée à vos décisions de trading ou pertes financières.
                                    </p>
                                </div>
                                <div className="flex justify-center space-x-6">
                                    <Button variant="outlined" color="error" onClick={() => $.trigger('on reject')}>
                                        Refuser
                                    </Button>
                                    <Button variant="contained" color="primary" onClick={() => $.trigger('on accept')}>
                                        Accepter
                                    </Button>
                                </div>
                                <br/>
                            </div>
                        </div>
                    </div>
                </ThemeProvider>
            );
        }
    }
}
registerBrick('019725e3cd3065b98bb3', TermsConditions);
